import {
  HeadingCompact00,
  Short01,
  SingleLineEllipsis,
} from 'module/ui/components/styles';
import { Typography } from 'antd';
import styled from 'styled-components';

const { Text } = Typography;
const RowItem = styled.div`
  padding: 0 var(--spacing-03);
  ${SingleLineEllipsis};
  display: flex;
  align-items: center;
  width: calc(100% - calc(2 * var(--spacing-03)));
`;

export const HeaderRowItem = styled(RowItem)`
  ${HeadingCompact00};
  color: var(--text-tertiary);
`;
export const HeaderRow = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr) 48px;
  height: 24px;
  border-bottom: 1px solid var(--table-border-color);
`;
export const FieldRowItem = styled(RowItem)``;
export const FieldRow = styled(HeaderRow)`
  height: 40px;
  &:hover {
    background-color: var(--table-row-hover);
  }
`;
const ResponsiveText = styled(Text)`
  overflow: hidden;
  text-wrap: nowrap;
  text-overflow: ellipsis;
  whitespace: nowrap;
  flex: 1;
  min-width: 0;
  ${Short01};
`;

export const Name = styled(ResponsiveText)`
  cursor: pointer;
`;
export const Description = styled(ResponsiveText)``;
export const MoreActionsRowItem = styled(FieldRowItem)`
  width: 100%;
`;
export const FieldListWrapper = styled.div`
  margin: 0 var(--spacing-06);
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
`;
